import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";

export const NumericInput = (props: numericInputProps) => {
  const [fieldValue, setFieldValue] = useState(props.value?.toString());

  useEffect(() => {
    setFieldValue(props.value?.toString());
  }, [props.value]);

  const valueChange = (value: string) => {
    if (!separatorList[separatorType].regex.test(value)) {
      setFieldValue("");
      props.ret(0);
      return;
    }

    setFieldValue(value);

    let nValue =
      separatorType === "no" ? parseInt(value, 10) : parseFloat(value);

    // != null so a min/max of 0 is still enforced
    if (props.minValue != null && nValue < props.minValue) {
      nValue = props.minValue;
      setFieldValue(nValue.toString());
    }

    if (props.maxValue != null && nValue > props.maxValue) {
      nValue = props.maxValue;
      setFieldValue(nValue.toString());
    }

    props.ret(nValue);
  };

  const decimalPositions = props.decimalPositions ?? 0;
  const separatorType = decimalPositions > 0 ? "period" : "no";

  return (
    <TextField
      placeholder={props.placeholder}
      label=""
      fullWidth
      variant="standard"
      margin="dense"
      className={`w-100 ${props.className ?? ""}`}
      hiddenLabel
      value={fieldValue}
      disabled={props.disabled}
      slotProps={{ htmlInput: { inputMode: "numeric", pattern: "[0-9]*" } }}
      onChange={({ target: { value } }) => valueChange(value)}
    />
  );
};

export interface numericInputProps {
  value?: number;
  decimalPositions?: number;
  maxValue?: number;
  minValue?: number;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  ret: (newValue: number) => void;
}

const separatorList = {
  no: {
    name: "comma",
    regex: /^\d+$/,
  },
  comma: {
    name: "comma",
    regex: /^\d+(,\d{0,2})?$/,
  },
  period: {
    name: "period",
    regex: /^\d+(\.\d{0,2})?$/,
  },
};
